/**
 * Componente: StepContainer
 * Wrapper padrão para todos os steps
 */

import React, { ReactNode } from 'react';

interface StepContainerProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

export const StepContainer: React.FC<StepContainerProps> = ({
  title,
  description,
  children,
  className = '',
}) => {
  return (
    <div className={`form-step-container ${className}`}>
      {title || description && (
        <div className="step-header">

          <h2 className="step-title">{title}</h2>

          {description && <p className="step-description">{description}</p>}
        </div>
      )}
      <div className="step-content">{children}</div>
    </div>
  );
};

export default StepContainer;
